import _ from "axios";
import Cookies from "js-cookie";
import * as Sentry from "@sentry/react";

export const baseUrl = import.meta.env.VITE_API_URL;

const axios = _.create({
  baseURL: baseUrl,
  //withCredentials: true,
  headers: {
    ...(Cookies.get("token") && {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }),
    "ngrok-skip-browser-warning": "69420",
  },
});

axios.interceptors.request.use(
  (config) => {
    // Track API calls
    Sentry.addBreadcrumb({
      category: "xhr",
      message: `${config.method?.toUpperCase()} ${config.url}`,
      level: "info",
    });
    const token = Cookies.get("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const deviceId = localStorage.getItem("unique_device_id");
    if (deviceId) {
      config.headers['unique-device-id'] = deviceId;
    }

    return config;
  },
  (error) => {
    Sentry.captureException(error);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    Sentry.captureException(error);
    return Promise.reject(error);
  }
);

export const AuthApi = _.create({
  baseURL: baseUrl,
  headers: {
    Authorization: `Bearer ${Cookies.get("token")}`,
    "ngrok-skip-browser-warning": "69420",
  },
});

export default axios;
